import { IVitalSign } from '../interface/vital-sign';
export class VitalSign implements IVitalSign {
    constructor(
       public PatientId: number,
       public Pulse : string,
       public Temperature : string,
       public BloodPressure : string,
       public PatientWeight : string,
       public RespiratoryRate : string,
       public EnteredBy : string,
       public AppointmentId : number,
       public VitalSignId : number,
       public AppointmentTime : string,
       public AppointmentDay : string
    ){}
}



// WEBPACK FOOTER //
// ./src/app/section/patient/model/vital-sign.ts